// import "regenerator-runtime/runtime";
import { Toaster } from 'react-hot-toast';
import { BrowserRouter } from 'react-router-dom';
import Router from './router/router';

const toasterStyle = {
	containerStyle: {
		zIndex: 999999999999999,
	},
	toastOptions: {
		style: {
			zIndex: 999999999999999,
		},
	},
};

const App = () => {
	return (
		<BrowserRouter>
			<Toaster {...toasterStyle} />
			<Router />
		</BrowserRouter>
	);
};

export default App;
